import {
  addStateHandlers,
  addWrapper,
  addProps,
  flowMax,
  SimpleUnchangedProps,
} from 'ad-hok'
import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'
import { createUseStyles } from 'react-jss'
import { Options as AnalyticsOptions } from 'shared/src/utils/analytics'
import { typedAs } from 'shared/src/utils/typedAs'

import { ConstrainWidth } from '../../utils/layout'
import { Banner as BannerComponent } from './Banner'

export type AnalyticsEventParams = Record<string, any>

interface AnalyticsEvent {
  options: AnalyticsOptions
  params?: AnalyticsEventParams
}

interface BannerButton {
  title: string
  navigateTo: string
  state?: any
  external?: boolean
  onClick?: () => void
  onClickAnalyticsEvent?: AnalyticsEvent
}

interface AppstoreButton {
  title: string
  navigateTo: string
  state?: any
  external?: boolean
  onClick?: () => void
  onClickAnalyticsEvent?: AnalyticsEvent
}

export interface Banner {
  textTranslationKey: string
  link?: BannerButton
  appstoreButton?: AppstoreButton
  onCloseAnalyticsEvent?: AnalyticsEvent
  unDismissable?: boolean
  noHider?: boolean
}

interface BannerContext {
  showBanner: (banner: Banner) => void
  clearBanner: () => void
}

const useStyles = createUseStyles({
  holder: {
    display: 'flex',
  },
})

export const [addBannerContextProviderInternal, addBannerContext] =
  getContextHelpers<BannerContext>(toObjectKeys(['showBanner', 'clearBanner']))

export const addBannerContextProvider: SimpleUnchangedProps = flowMax(
  addProps(() => ({
    classes: useStyles(),
  })),
  addStateHandlers(
    { banner: typedAs<Banner | null>(null) },
    {
      showBanner: () => (banner: Banner) => ({
        banner,
      }),
      clearBanner: () => () => ({
        banner: null,
      }),
    }
  ),
  addWrapper((render, { banner, clearBanner, classes }) => (
    <>
      {banner && (
        <ConstrainWidth className={classes.holder}>
          <BannerComponent banner={banner} onAction={clearBanner} />
        </ConstrainWidth>
      )}
      {render()}
    </>
  )),
  addBannerContextProviderInternal
)
